module.exports = __webpack_public_path__ + "static/media/user.ed58d917.png";